import { UserRole } from "@/core/services/api/enums/UserRole";
import store from "@/store";
import { RouteLocationRaw } from "vue-router";

export const isUserRoleIn = (
  roles: UserRole[] | string[] | undefined
): boolean => {
  if (!roles) {
    return true;
  }
  const userRoles = store.getters.userRoleSlugs;
  if (!userRoles || !Array.isArray(userRoles)) {
    return false;
  }

  return roles.some((role: UserRole | string) => !!~userRoles.indexOf(role));
};

export const isUserAdmin = (): boolean => {
  return store.getters.isAdmin;
};

export const isUserManager = (): boolean => {
  return store.getters.isManager;
};

export const isUserRole = (role: string | UserRole | undefined): boolean => {
  if (!role) {
    return true;
  }
  const userRoles = store.getters.userRoleSlugs;
  if (!userRoles || !Array.isArray(userRoles)) {
    return false;
  }

  return !!~userRoles.indexOf(role);
};

export const getDashboardRoute = (): RouteLocationRaw => {
  if (store.getters.isAdmin) {
    return { name: "admin.dashboard" };
  }

  return { name: "manager.dashboard" };
};
